export const ROUTE_INDEX = '/'
export const ROUTE_404 = '*'
export const ROUTE_ERROR = '/public/error'

export const ROUTE_NOT_FOUND = '/notFound'

export const ROUTE_PASSWORD_RECOVERY = '/public/recuperacionPassword'
export const ROUTE_PASSWORD_RESET = '/public/resetPassword'
export const ROUTE_USER_RECOVERY = '/userRecovery'
